
import { Component, Prop } from 'vue-property-decorator'
import BaseCampsiteCard from './BaseCampsiteCard.vue'
import { PuCampsiteCardLocationSectionProps } from './PuCampsiteCardLocationSectionProps'

@Component
export default class PuCampsiteCard extends BaseCampsiteCard {
  @Prop({ required: false })
    searchResultIndex: number

  get locationSectionProps(): PuCampsiteCardLocationSectionProps {
    return {
      hierarchyStringShort: this.hierarchyStringShort,
      distance: this.distance,
      isPointSearch: this.isPointSearch,
    }
  }
}
